var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-row",
        { staticClass: "padding_5px_top" },
        [
          _c(
            "el-tabs",
            {
              attrs: { id: "rankingTab" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("div", { staticStyle: { margin: "15px 0" } }),
              _vm._v(" "),
              _c(
                "el-checkbox-group",
                {
                  staticStyle: {
                    "margin-top": "-8px",
                    float: "left",
                    "margin-bottom": "40px",
                  },
                  on: { change: _vm.handleCheckedCitiesChange },
                  model: {
                    value: _vm.checkedCities,
                    callback: function ($$v) {
                      _vm.checkedCities = $$v
                    },
                    expression: "checkedCities",
                  },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      key: "firth",
                      attrs: { name: "firth", label: "firth" },
                      on: { click: _vm.firthClick, change: _vm.firthChange },
                    },
                    [_vm._v("全部")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "second",
                      attrs: { name: "second", label: "second" },
                      on: { click: _vm.secondClick, change: _vm.secondChange },
                    },
                    [_vm._v("业绩评分")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "third",
                      attrs: { name: "third", label: "third" },
                      on: { click: _vm.thirdClick, change: _vm.thirdChange },
                    },
                    [_vm._v("规模")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "fourth",
                      attrs: { name: "fourth", label: "fourth" },
                      on: { click: _vm.fourthClick, change: _vm.fourthChange },
                    },
                    [_vm._v("资金流")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "fifth",
                      attrs: { name: "fifth", label: "fifth" },
                      on: { click: _vm.fifthClick, change: _vm.fifthChange },
                    },
                    [_vm._v("产品线")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "sixth",
                      attrs: { name: "sixth", label: "sixth" },
                      on: { click: _vm.sixthClick, change: _vm.sixthChange },
                    },
                    [_vm._v("综合星级")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "seventh",
                      attrs: { name: "seventh", label: "seventh" },
                      on: {
                        click: _vm.seventhClick,
                        change: _vm.seventhChange,
                      },
                    },
                    [_vm._v("管理团队")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      key: "eighth",
                      attrs: { name: "eighth", label: "eighth" },
                      on: { click: _vm.eighthClick, change: _vm.eighthChange },
                    },
                    [_vm._v("费率")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "tableList",
          staticClass: "tableSpecial",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            height: "600",
            "default-sort": { prop: "", order: "descending" },
          },
          on: {
            "sort-change": _vm.sortChange,
            "filter-change": _vm.filterChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "defaultSymbol",
              label: "序号",
              width: "70",
              "render-header": _vm.renderheaderRefreshData,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.pagination.skip + (scope.$index + 1)) + " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "companyNameCN",
              label: "基金公司名称",
              "min-width": "200",
              "class-name": "gongsiClass",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.redirectCompanyReportDataPage(
                              scope.row.companyId
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.companyNameCN))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.pinfenShow
            ? _c(
                "el-table-column",
                { key: "1", attrs: { label: "", align: "center" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", [_vm._v("业绩评分")]),
                  ]),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "classCount",
                      label: "参评基金数量(综合)",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.classCount,
                                      scope.row.classCount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      868377383
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticStyle: { "background-color": "red !important" },
                    attrs: {
                      prop: "companyScoreRaw",
                      label: "总分值(综合)",
                      "min-width": "130",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.companyScoreRaw,
                                      scope.row.companyScoreRaw
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1284955591
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sizeType",
                      label: "规模分类(综合)",
                      "min-width": "170",
                      align: "center",
                      "column-key": "tag1",
                      filters: this.sizeTypeArr,
                      "filter-placement": "bottom-end",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.sizeType == 1
                                ? _c("span", [_vm._v("大型")])
                                : scope.row.sizeType == 2
                                ? _c("span", [_vm._v("中型")])
                                : scope.row.sizeType == 3
                                ? _c("span", [_vm._v("小型")])
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3964754847
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "companyScoreRawRank",
                      label: "排名(综合)",
                      "min-width": "120",
                      sortable: "custom",
                      align: "center",
                      "class-name": "pinfenClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.sizeType == 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.companyScoreRawRank +
                                            "/" +
                                            scope.row.allBigSum,
                                          scope.row.companyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.sizeType == 2
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.companyScoreRawRank +
                                            "/" +
                                            scope.row.allMiddleSum,
                                          scope.row.companyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.sizeType == 3
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.companyScoreRawRank +
                                            "/" +
                                            scope.row.allSmallSum,
                                          scope.row.companyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2410187718
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "eqallocclassCount",
                      label: "参评基金数量(偏股)",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.eqallocclassCount,
                                      scope.row.eqallocclassCount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      67604359
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticStyle: { "background-color": "red !important" },
                    attrs: {
                      prop: "eqalloccompanyScoreRaw",
                      label: "总分值(偏股)",
                      "min-width": "140",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.eqalloccompanyScoreRaw,
                                      scope.row.eqalloccompanyScoreRaw
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2878909383
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "eqallocsizeType",
                      label: "规模分类(偏股)",
                      "min-width": "180",
                      align: "center",
                      "column-key": "tag2",
                      filters: this.eqallocSizeTypeArr,
                      "filter-placement": "bottom-end",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.eqallocsizeType == 1
                                ? _c("span", [_vm._v("大型")])
                                : scope.row.eqallocsizeType == 2
                                ? _c("span", [_vm._v("中型")])
                                : scope.row.eqallocsizeType == 3
                                ? _c("span", [_vm._v("小型")])
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      920028678
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "eqalloccompanyScoreRawRank",
                      label: "排名(偏股)",
                      "min-width": "130",
                      sortable: "custom",
                      align: "center",
                      "class-name": "pinfenClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.eqallocsizeType == 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.eqalloccompanyScoreRawRank +
                                            "/" +
                                            scope.row.eqallocbigSum,
                                          scope.row.eqalloccompanyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.eqallocsizeType == 2
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.eqalloccompanyScoreRawRank +
                                            "/" +
                                            scope.row.eqallocmiddleSum,
                                          scope.row.eqalloccompanyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.eqallocsizeType == 3
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.eqalloccompanyScoreRawRank +
                                            "/" +
                                            scope.row.eqallocsmallSum,
                                          scope.row.eqalloccompanyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      358408711
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fxincclassCount",
                      label: "参评基金数量(固收)",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fxincclassCount,
                                      scope.row.fxincclassCount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      526026119
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticStyle: { "background-color": "red !important" },
                    attrs: {
                      prop: "fxinccompanyScoreRaw",
                      label: "总分值(固收)",
                      "min-width": "130",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fxinccompanyScoreRaw,
                                      scope.row.fxinccompanyScoreRaw
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1026766759
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fxincsizeType",
                      label: "规模分类(固收)",
                      "min-width": "170",
                      align: "center",
                      "column-key": "tag3",
                      filters: this.fxincSizeTypeArr,
                      "filter-placement": "bottom-end",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fxincsizeType == 1
                                ? _c("span", [_vm._v("大型")])
                                : scope.row.fxincsizeType == 2
                                ? _c("span", [_vm._v("中型")])
                                : scope.row.fxincsizeType == 3
                                ? _c("span", [_vm._v("小型")])
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2808747589
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fxinccompanyScoreRawRank",
                      label: "排名(固收)",
                      "min-width": "120",
                      sortable: "custom",
                      align: "center",
                      "class-name": "pinfenClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fxincsizeType == 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.fxinccompanyScoreRawRank +
                                            "/" +
                                            scope.row.fxincbigSum,
                                          scope.row.fxinccompanyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.fxincsizeType == 2
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.fxinccompanyScoreRawRank +
                                            "/" +
                                            scope.row.fxincmiddleSum,
                                          scope.row.fxinccompanyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.fxincsizeType == 3
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.fxinccompanyScoreRawRank +
                                            "/" +
                                            scope.row.fxincsmallSum,
                                          scope.row.fxinccompanyScoreRawRank
                                        )
                                      )
                                    ),
                                  ])
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2150726823
                    ),
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.guimoShow
            ? _c(
                "el-table-column",
                { key: "2", attrs: { label: "规模", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSize",
                      label: "规模-不含货币基金(亿元)",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSize,
                                      scope.row.fundSize
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1810379015
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    staticClass: "borderLeft",
                    attrs: {
                      prop: "fundSizeRank",
                      label: "排名",
                      "min-width": "100",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeRank,
                                      scope.row.fundSizeRank
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1321173703
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundCount",
                      label: "份额数量",
                      "min-width": "110",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundCount,
                                      scope.row.fundCount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2384733703
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundCountRank",
                      label: "排名",
                      "min-width": "100",
                      sortable: "custom",
                      align: "center",
                      "class-name": "guimoClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundCountRank,
                                      scope.row.fundCountRank
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1203760903
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.zijinliuShow
            ? _c(
                "el-table-column",
                { key: "3", attrs: { label: "资金流", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlow_1Y",
                      label: "最近一年资金流(亿元)",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlow_1Y,
                                      scope.row.fundSizeFlow_1Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1157112327
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlowRank_1Y",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlowRank_1Y,
                                      scope.row.fundSizeFlowRank_1Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2757531207
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlowPer_1Y",
                      label: "最近一年资金流增长率",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlowPer_1Y,
                                      scope.row.fundSizeFlowPer_1Y
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(
                                scope.row.fundSizeFlowPer_1Y
                              )
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4132266170
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlowPerRank_1Y",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlowPerRank_1Y,
                                      scope.row.fundSizeFlowPerRank_1Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3854966151
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlow_3Y",
                      label: "最近三年资金流(亿元)",
                      "min-width": "190",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlow_3Y,
                                      scope.row.fundSizeFlow_3Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      398888583
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlowRank_3Y",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlowRank_3Y,
                                      scope.row.fundSizeFlowRank_3Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2653315271
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlowPer_3Y",
                      label: "最近三年资金流增长率",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlowPer_3Y,
                                      scope.row.fundSizeFlowPer_3Y
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(
                                scope.row.fundSizeFlowPer_3Y
                              )
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2618577016
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fundSizeFlowPerRank_3Y",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                      "class-name": "zijinliuClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fundSizeFlowPerRank_3Y,
                                      scope.row.fundSizeFlowPerRank_3Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4273812167
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.chanpinxianShow
            ? _c(
                "el-table-column",
                { key: "4", attrs: { label: "产品线", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "equity",
                      label: "股票(亿元)",
                      "min-width": "110",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.equity,
                                      scope.row.equity
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2425168167
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "equityrank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.equity != ""
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.equityrank,
                                          scope.row.equityrank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.equity == ""
                                ? _c("span", [_vm._v("--")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3328143795
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "alloc",
                      label: "混合(亿元)",
                      "min-width": "110",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.alloc,
                                      scope.row.alloc
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2831838727
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "allocrank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.alloc != ""
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.allocrank,
                                          scope.row.allocrank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.alloc == ""
                                ? _c("span", [_vm._v("--")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3308713747
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fxinc",
                      label: "固收(亿元)",
                      "min-width": "110",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.fxinc,
                                      scope.row.fxinc
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3560809991
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fxincrank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fxinc != ""
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.fxincrank,
                                          scope.row.fxincrank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.fxinc == ""
                                ? _c("span", [_vm._v("--")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1104263539
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mnmkt",
                      label: "货币(亿元)",
                      "min-width": "110",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.mnmkt,
                                      scope.row.mnmkt
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2362047111
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mnmktrank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.mnmkt != ""
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.mnmktrank,
                                          scope.row.mnmktrank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.mnmkt == ""
                                ? _c("span", [_vm._v("--")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1315418387
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "other",
                      label: "其它(亿元)",
                      "min-width": "120",
                      sortable: "custom",
                      align: "center",
                      "class-name": "chanpinxianClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.other,
                                      scope.row.other
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2891308487
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.zongheyejiShow
            ? _c(
                "el-table-column",
                { key: "5", attrs: { label: "综合星级", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "star1Per",
                      label: "一星基金规模占比",
                      "min-width": "160",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.star1Per,
                                      scope.row.star1Per
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(scope.row.star1Per)
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2583509254
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "star2Per",
                      label: "两星基金规模占比",
                      "min-width": "160",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.star2Per,
                                      scope.row.star2Per
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(scope.row.star2Per)
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      837387493
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "star3Per",
                      label: "三星基金规模占比",
                      "min-width": "160",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.star3Per,
                                      scope.row.star3Per
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(scope.row.star3Per)
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1156327492
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "star4Per",
                      label: "四星基金规模占比",
                      "min-width": "160",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.star4Per,
                                      scope.row.star4Per
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(scope.row.star4Per)
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3073202211
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "star5Per",
                      label: "五星基金规模占比",
                      "min-width": "160",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.star5Per,
                                      scope.row.star5Per
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(scope.row.star5Per)
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1985770882
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "aumweightedStar",
                      label: "加权星级",
                      "min-width": "110",
                      sortable: "custom",
                      align: "center",
                      "class-name": "zongheyejiClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.aumweightedStar,
                                      scope.row.aumweightedStar
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3245832327
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.xintuozerenShow
            ? _c(
                "el-table-column",
                { key: "6", attrs: { label: "管理团队", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "managerCount",
                      label: "基金经理人数",
                      "min-width": "130",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.managerCount,
                                      scope.row.managerCount
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2017969031
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "managerCountRank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.managerCountRank,
                                      scope.row.managerCountRank
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3600388295
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "managerCareerTime",
                      label: "基金经理平均投资管理年限",
                      "min-width": "220",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNullRound")(
                                      scope.row.managerCareerTime,
                                      2
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1608079987
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "managerCareerTimeRank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.managerCareerTimeRank,
                                      scope.row.managerCareerTimeRank
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2851947271
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "managerStayTime",
                      label: "基金经理平均在职时长",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNullRound")(
                                      scope.row.managerStayTime,
                                      2
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      545167438
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "managerStayTimeRank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.managerStayTimeRank,
                                      scope.row.managerStayTimeRank
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      985652807
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "retention_3Y",
                      label: "最近三年留职率",
                      "min-width": "200",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNullRound")(
                                      scope.row.retention_3Y,
                                      2
                                    )
                                  )
                                ),
                              ]),
                              _vm.checkDataHasValue(scope.row.retention_3Y)
                                ? _c("span", [_vm._v("%")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      845556916
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "retentionRank_3Y",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      "class-name": "xintuozerenClass",
                      sortable: "custom",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.retentionRank_3Y,
                                      scope.row.retentionRank_3Y
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2555261031
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.feilvShow
            ? _c(
                "el-table-column",
                { key: "7", attrs: { label: "费率", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "terscore",
                      label: "运营费率综合得分",
                      "min-width": "160",
                      sortable: "custom",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("fillNull")(
                                      scope.row.terscore,
                                      scope.row.terscore
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      881730983
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "terscoreRank",
                      label: "排名",
                      "min-width": "100",
                      align: "center",
                      sortable: "custom",
                      "class-name": "feilvClass",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.terscoreRank != "0"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("fillNull")(
                                          scope.row.terscoreRank,
                                          scope.row.terscoreRank
                                        )
                                      )
                                    ),
                                  ])
                                : scope.row.terscoreRank == "0"
                                ? _c("span", [_vm._v("--")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2074162611
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "left_text_align padding_25px_top" },
        [
          (_vm.pagination.count > 10 ? true : false)
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.params.page,
                  "page-sizes": [10, 20, 50, 100, 200],
                  "page-size": _vm.pagination.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: (_vm.pagination && _vm.pagination.count) || 0,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.params, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.params, "page", $event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }